import Vue from 'vue';
import NoviLogging from './services/NoviLogging';
import '../common/GlobalVeeValidateConfig';

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.config.errorHandler = (err, vm, info) => {
    NoviLogging.exception(err, {vueModel: vm, info});
}